export default __webpack_public_path__ + "static/media/DNo.30-2.f03faf8f.jpg";